// extracted by mini-css-extract-plugin
export default {"Radio":"ColorPicker-module__Radio--g4qIB"};